import { ApiState } from "infrastructure/api";
import type { RootState } from "infrastructure/store";
import { compareIds } from "util/support";
import type { ID } from "types";
import type { Application } from "./types";

export const selectIsApplicationsUninitialized = (state: RootState) =>
    state.onboarding.tableLoadingState === ApiState.Idle;

export const selectIsApplicationsLoading = (state: RootState) =>
    state.onboarding.tableLoadingState === ApiState.Pending;

export const selectApplicationsSlice = (state: RootState) => state.onboarding.tableSlice;

export const selectIsExportApplicationsLoading = (state: RootState) =>
    state.onboarding.exportLoadingState === ApiState.Pending;

export const selectApplicationById = (pki: ID) => (state: RootState) =>
    selectApplicationsSlice(state)
        ?.data
        .find((application: Application) => (
            compareIds(application.pki, pki)
        ));
